import { NgClass } from '@angular/common';
import { Component, OnInit, Renderer2, ViewEncapsulation, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { GlobalSearchComponent } from '../search/global-search.component';
import { BannerComponent } from '../shared/banner.component';
import { PermanentBannerComponent } from '../shared/permanent-banner.component';
import { ToastComponent } from '../shared/toast/toast.component';
import { ThemeService } from '../utility/theme.service';
import { NavComponent } from './nav.component';

@Component({
  selector: 'base-layout',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
  imports: [
    BannerComponent,
    GlobalSearchComponent,
    NavComponent,
    NgClass,
    PermanentBannerComponent,
    RouterOutlet,
    ToastComponent
  ],
  encapsulation: ViewEncapsulation.None
})
export class BaseComponent implements OnInit {
  private themeService = inject(ThemeService);
  private renderer = inject(Renderer2);

  isDarkMode: boolean = false;

  ngOnInit(): void {
    this.themeService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;

      if (isDarkMode) {
        this.renderer.addClass(document.body, 'dark-theme');
      } else {
        this.renderer.removeClass(document.body, 'dark-theme');
      }
    });
  }
}
